export function isMarketingHost() {
  if (typeof window === 'undefined') return false;

  const host = window.location.hostname.toLowerCase();
  const configuredHosts = [
    process.env.REACT_APP_MARKETING_DOMAIN,
    ...(process.env.REACT_APP_MARKETING_HOSTS || '').split(','),
  ]
    .map((value) => String(value || '').trim().toLowerCase())
    .filter(Boolean);

  if (configuredHosts.length > 0) {
    return configuredHosts.includes(host);
  }

  return host === 'silstechsrms.com' || host === 'www.silstechsrms.com';
}
